import { z } from 'zod';
import {
  StudentId,
  FamilyId,
  ChildApplicationId,
} from '../types/branded';
import { GradeLevel, SchoolDivision, StudentGenderSchema, StudentStatusSchema } from '../types/enums';

export const StudentSchema = z.object({
  id: StudentId,
  familyId: FamilyId,
  childAppId: ChildApplicationId.nullable().optional(),
  firstName: z.string().min(1),
  lastName: z.string().min(1),
  preferredName: z.string().nullable().optional(),
  hebrewFirstName: z.string().nullable().optional(),
  hebrewLastName: z.string().nullable().optional(),
  dateOfBirth: z.string().nullable().optional(),
  gender: StudentGenderSchema.nullable().optional(),
  grade: GradeLevel,
  gradeApplyingFor: GradeLevel.nullable().optional(),
  applyingForYear: z.string().nullable().optional(),
  division: SchoolDivision,
  status: StudentStatusSchema,
  placeOfBirth: z.string().nullable().optional(),
  homeLanguage: z.string().nullable().optional(),
  currentSchool: z.string().nullable().optional(),
  rateCategory: z.string().nullable().optional(),
  principalName: z.string().nullable().optional(),
  principalPhone: z.string().nullable().optional(),
  pediatrician: z.string().nullable().optional(),
  pediatricianPhone: z.string().nullable().optional(),
  dentist: z.string().nullable().optional(),
  dentistPhone: z.string().nullable().optional(),
  caseOwnerId: z.string().nullable().optional(),
  caseOwnerName: z.string().nullable().optional(),
  enrollmentDate: z.string().nullable().optional(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type Student = z.infer<typeof StudentSchema>;
